var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEffect = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98165 13.7033C5.4593 13.7033 5.8501 13.3179 5.8501 12.8469V4.28228C5.8501 3.81123 5.4593 3.42583 4.98165 3.42583C4.504 3.42583 4.1132 3.81123 4.1132 4.28228V12.8469C4.1132 13.3179 4.504 13.7033 4.98165 13.7033ZM8.45545 17.1291C8.93309 17.1291 9.3239 16.7437 9.3239 16.2727V0.856457C9.3239 0.385406 8.93309 0 8.45545 0C7.9778 0 7.587 0.385406 7.587 0.856457V16.2727C7.587 16.7437 7.9778 17.1291 8.45545 17.1291ZM1.50785 10.2775C1.9855 10.2775 2.3763 9.89208 2.3763 9.42102V7.70811C2.3763 7.23706 1.9855 6.85165 1.50785 6.85165C1.03021 6.85165 0.639404 7.23706 0.639404 7.70811V9.42102C0.639404 9.89208 1.03021 10.2775 1.50785 10.2775ZM11.9292 13.7033C12.4069 13.7033 12.7977 13.3179 12.7977 12.8469V4.28228C12.7977 3.81123 12.4069 3.42583 11.9292 3.42583C11.4516 3.42583 11.0608 3.81123 11.0608 4.28228V12.8469C11.0608 13.3179 11.4516 13.7033 11.9292 13.7033ZM14.5346 7.70811V9.42102C14.5346 9.89208 14.9254 10.2775 15.403 10.2775C15.8807 10.2775 16.2715 9.89208 16.2715 9.42102V7.70811C16.2715 7.23706 15.8807 6.85165 15.403 6.85165C14.9254 6.85165 14.5346 7.23706 14.5346 7.70811Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEffect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/effect.368901e09f98299ff35fe3870a424946.svg";